import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

import logo from './../../assets/logo.png'
import logoSGE from './../../assets/logoSGE.png'
import api from '../../services/api'
import { TOKEN_KEY, IDUSER, USER_DATA, IDCOMPANY, isAuthenticated, USERNAME, REGISTRATION, ReadDataStorage, WriteDataStorage, CONTRACT, EXPIRES_IN, CONTRACTSTATUS} from '../../services/auth'
import ShowMessages from '../../components/Exceptions'

import { ValidationForm, TextInput } from 'react-bootstrap4-form-validation';

import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { NotificationManager } from 'react-notifications';
import { GetCookieMessage, SetCookieMessage } from './../../components/Cookies';

import  loadingButton  from './../layouts/Buttons'

import setStatistic from './../../services/apiStatistic'

export default function Login(props) {
    const [update, setUpdate]                   = useState(false)
    const [registration, setRegistration]       = useState('')
    const [password, setPassword]               = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [remember, setRemember]               = useState(false)
    const [mfaStep, setMfaStep]                 = useState(false)
    const [mfaToken, setMfaToken]               = useState('')
    const [mfaCode, setMfaCode]                 = useState('')

    const matchPassword = (value) => {
        return value && value === password;   
    }


    useEffect(() => {

        if (GetCookieMessage('LoginMsg',"") !== "") {
            NotificationManager.error(GetCookieMessage('LoginMsg',""), 'Erro!', 4000);
            SetCookieMessage('LoginMsg',"")
        }
        
        let _passOnFocus = false
        if ((ReadDataStorage(REGISTRATION) !== "" ) && (ReadDataStorage(REGISTRATION) !== null)) {
            setRegistration(ReadDataStorage(REGISTRATION))
            setRemember(true)
            _passOnFocus = true
        }
            

        if (isAuthenticated())
            window.location.href = '/'
        else {
            if (_passOnFocus) 
                document.querySelector('#password').focus()
            else
                document.querySelector('#registration').focus()
        }
            
    },[])

    useEffect(() => {
        setStatistic('login')
    } ,[])



    const persistSessionAndRedirect = (responseData) => {
        const { token, user, idcompany } = responseData
        WriteDataStorage(TOKEN_KEY, JSON.stringify(token))
        WriteDataStorage(USER_DATA, JSON.stringify(user))
        WriteDataStorage(IDCOMPANY, idcompany)
        WriteDataStorage(USERNAME, responseData.user.name)
        WriteDataStorage(IDUSER, responseData.user.iduser)
        WriteDataStorage(CONTRACT, responseData.hash)
        WriteDataStorage(EXPIRES_IN, responseData.expires_in)
        WriteDataStorage(CONTRACTSTATUS, responseData.idcontractstatus)
        if (remember === true)
            WriteDataStorage(REGISTRATION, registration)
        else
            WriteDataStorage(REGISTRATION, '')
        window.location.href = '/'
    }

    const handleSubmitMfa = async (event) => {
        event.preventDefault()
        loadingButton(true, document.querySelector('#mfa-submit'), 'fa fa-shield-alt', document.querySelector('#mfa-submit').lastChild.nodeValue)
        try {
            await api.post('/authenticate/mfa', { mfaToken, code: mfaCode.replace(/\D/g, '') })
                .then(response => {
                    if (response.ok && response.data && !response.data.mfaRequired) {
                        setMfaStep(false)
                        setMfaToken('')
                        setMfaCode('')
                        persistSessionAndRedirect(response.data)
                    } else {
                        loadingButton(false, document.querySelector('#mfa-submit'), 'fa fa-shield-alt', 'Confirmar código')
                    }
                })
        } catch (e) {
            loadingButton(false, document.querySelector('#mfa-submit'), 'fa fa-shield-alt', 'Confirmar código')
            setMfaCode('')
        }
    }

    const cancelMfa = () => {
        setMfaStep(false)
        setMfaToken('')
        setMfaCode('')
        setPassword('')
    }

    const handleSubmit = async(event) => {
        if (update)
            loadingButton(true,document.querySelector('#update-password'),document.querySelector('#update-password').children[0].classList,document.querySelector('#update-password').lastChild.nodeValue)
        else
            loadingButton(true,document.querySelector('#submit'),document.querySelector('#submit').children[0].classList,document.querySelector('#submit').lastChild.nodeValue)

        event.preventDefault()
        try {
            await api.post('/authenticate', {
                registration,
                password,
                update
            })
                .then(response => {
                    if (response.ok) {
                        if (response.data.update) {
                            setUpdate(true)
                            setPassword('')
                            setMfaStep(false)
                            setMfaToken('')
                            setMfaCode('')
                            document.querySelector('#password').focus()
                        } else if(response.data.redirect){ 
                            ShowMessages(response.data.message);
                            setUpdate(false)
                            setPassword('')
                            setMfaStep(false)
                            window.location.href = '/login'
                        } else if (response.data.mfaRequired && response.data.mfaToken) {
                            setMfaStep(true)
                            setMfaToken(response.data.mfaToken)
                            setMfaCode('')
                            NotificationManager.info('Enviamos um código de verificação para o seu e-mail.', 'MFA', 5000)
                            loadingButton(false,document.querySelector('#submit'),'fa fa-sign-in-alt','Acessar')
                        } else  {  
                            setUpdate(false)
                            setMfaStep(false)
                            setMfaToken('')
                            setMfaCode('')
                            persistSessionAndRedirect(response.data)
                        }
                    } else {
                        if (update)
                            loadingButton(false,document.querySelector('#update-password'),'fa fa-key','Alterar Senha')
                        else
                            loadingButton(false,document.querySelector('#submit'),'fa fa-sign-in-alt','Acessar')
                    }
                })
        } catch (response) {
            localStorage.clear();
            if (update)
                loadingButton(false,document.querySelector('#update-password'),'fa fa-key','Alterar Senha')
            else
                loadingButton(false,document.querySelector('#submit'),'fa fa-sign-in-alt','Acessar')

            setRegistration('')
            setPassword('')
        }
    }

    return (
        <>
        <div className={`${window.location.href.indexOf('sgecont') > 0 ? 'background-sge' : 'background'}`}>
        </div>
        <div style={{height: "100vh", display: "flex", justifyContent: "center", alignItems: "center"}}>
            <NotificationContainer />
            <div className="content">
                <div className="block-center wd-xl">
                    <div className="card card-flat">
                        <div className="card-header text-center bg-blue">
                            <Link to="/login">
                                 {window.location.href.indexOf('sgecont') > 0 ? 
                                     <img className="block-center rounded imgWidth" src={logoSGE} alt={process.env.REACT_APP_NAME} />
                                :
                                     <img className="block-center rounded imgWidth" src={logo} alt={process.env.REACT_APP_NAME} />
                                 }
                               
                            </Link>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", padding: "5px", fontSize: '12px', color: "#cacaca" }}>
                            Versão: {process.env.REACT_APP_VERSION}
                        </div>
                        <div className="card-body">
                            {update === false && mfaStep ? (
                                <ValidationForm onSubmit={handleSubmitMfa} setFocusOnError={true}>
                                    <p className="text-muted" style={{ fontSize: '14px' }}>Digite o código de 6 dígitos enviado ao seu e-mail.</p>
                                    <div className="input-group mb-3">
                                        <TextInput
                                            name="mfacode"
                                            id="mfacode"
                                            type="text"
                                            inputMode="numeric"
                                            placeholder="Código"
                                            required
                                            maxLength={6}
                                            minLength={6}
                                            pattern="\d{6}"
                                            errorMessage={{
                                                required: 'Informe o código de 6 dígitos.',
                                                minLength: 'Digite os {minLength} dígitos do código.',
                                                pattern: 'Use apenas números (6 dígitos).'
                                            }}
                                            value={mfaCode}
                                            className="form-control"
                                            onChange={e => setMfaCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                            autoComplete="one-time-code"
                                            autoFocus
                                        />
                                    </div>
                                    <button className="btn btn-block btn-theme mt-3" type="submit" id="mfa-submit" style={{ width: '100%' }}>
                                        <em className="fa fa-shield-alt"></em> Confirmar código
                                    </button>
                                    <button type="button" className="btn btn-block btn-default mt-2" style={{ width: '100%' }} onClick={cancelMfa}>
                                        Voltar
                                    </button>
                                </ValidationForm>
                            ) : (
                            <ValidationForm onSubmit={handleSubmit} setFocusOnError={true}> 
                                {update === false ? 
                                
                                <div>
                                    <div className="input-group mb-3">
                                        <TextInput
                                            name="registration"
                                            id="registration"
                                            type="text"
                                            placeholder="Usuário"
                                            required
                                            maxLength={60}
                                            errorMessage={{ required: "Por favor, informe um usuário válido!"}}
                                            value={registration}
                                            className="form-control "
                                            onChange={e => setRegistration(e.target.value.toUpperCase())}
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="input-group mb-2">
                                        <TextInput
                                            name="password"
                                            id="password"
                                            type="password"
                                            placeholder="Senha"
                                            required
                                            maxLength={20}
                                            errorMessage={{ required: "Por favor, informe uma senha válida!" }}
                                            value={password}
                                            className="form-control"
                                            onChange={e => setPassword(e.target.value)}
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="input-group mb-4">                              
                                        <div className="checkbox c-checkbox">                                       
                                            <label><input type="checkbox" checked={remember} className="form-check-input" value={remember} onChange={e => setRemember(!remember)}/><span className="fa fa-check"></span>Lembrar minha matrícula</label>
                                        </div>
                                    </div>

                                    <button className="btn btn-block btn-theme mt-3" type="submit" id="submit" style={{width:"100%"}}><em className="fa fa-sign-in-alt"></em> Acessar</button>

                                    <div className="clearfix" style={{marginTop:"15px"}}>
                                        <div className="float-right">
                                            <Link to="/forgot" className="text-muted">Esqueceu sua senha?</Link>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div>
                                    <div className="input-group mb-2">
                                        <TextInput
                                            name="password"
                                            id="password"
                                            type="password"
                                            placeholder="Informe uma nova senha"
                                            required
                                            errorMessage={{ required: "Por favor, informe uma senha válida!",pattern:"A senha devem conter pelo menos 6 dígitos."  }}
                                            value={password}
                                            autoFocus={true}
                                            pattern="(?=.*[A-Z,0-9,!@#$%&*()-=+,.;:/}{\|}]).{6,}"
                                            className="form-control"
                                            onChange={e => setPassword(e.target.value)}
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="input-group mb-2">
                                        <TextInput
                                            name="confirmPassword"
                                            id="confirmPassword"
                                            type="password"
                                            placeholder="Repita a nova senha"
                                            required
                                            errorMessage={{ required: "Por favor, informe uma senha válida!",validator : "As senhas informadas não conferem.",pattern:"A senha devem conter pelo menos 6 dígitos."  }}
                                            value={confirmPassword}
                                            validator={matchPassword}
                                            pattern="(?=.*[A-Z,0-9,!@#$%&*()-=+,.;:/}{\|}]).{6,}"
                                            className="form-control"
                                            onChange={e => setConfirmPassword(e.target.value)}
                                            autoComplete="off"
                                        />
                                    </div>
                                    <button className="btn btn-block btn-theme mt-3" type="submit" id="update-password" style={{width:"100%"}}><em className="fa fa-key"></em> Alterar Senha</button>
                                </div>
                            }    
                            </ValidationForm>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )

}


